/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Replace_Once_ToastInputs */

const en_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected result replaced successfully`)
};

const fr_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le resultat selectionne a ete remplace avec succes`)
};

const de_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewähltes Ergebnis erfolgreich ersetzt`)
};

const it_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il risultato selezionato è stato sostituito correttamente`)
};

const ru_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранный результат успешно заменен.`)
};

const es_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado seleccionado reemplazado exitosamente`)
};

const zh_cn2_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已成功替换所选结果`)
};

const ja_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択した結果が正常に置き換えられました`)
};

const hi_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित परिणाम सफलतापूर्वक प्रतिस्थापित हो गया`)
};

const pt_pt2_find_replace_replace_once_toast = /** @type {(inputs: Find_Replace_Replace_Once_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado selecionado substituído com sucesso`)
};

/**
* | output |
* | --- |
* | "Selected result replaced successfully" |
*
* @param {Find_Replace_Replace_Once_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_replace_once_toast = /** @type {((inputs?: Find_Replace_Replace_Once_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Replace_Once_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_replace_once_toast(inputs)
	if (locale === "de") return de_find_replace_replace_once_toast(inputs)
	if (locale === "it") return it_find_replace_replace_once_toast(inputs)
	if (locale === "ru") return ru_find_replace_replace_once_toast(inputs)
	if (locale === "es") return es_find_replace_replace_once_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_replace_once_toast(inputs)
	if (locale === "ja") return ja_find_replace_replace_once_toast(inputs)
	if (locale === "hi") return hi_find_replace_replace_once_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_replace_once_toast(inputs)
	return en_find_replace_replace_once_toast(inputs)
});